import React from "react";
import { map } from "lodash";
import { Metric } from "@linkfluence/models/metric";
import Dropdown from "@radarly/components/panels/card-edition/sidebar/dropdown";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { PostsCard } from "@radarly/models/cards";
import { editSortOnPostCard } from "@radarly/models/cards/editor";
import { getPostSort } from "@radarly/models/cards/form";
import { Sort } from "@radarly/models/search";

export interface SharedPanelsCardEditionSidebarPaginationSortProps {
  card: PostsCard;
  setCard: (card: PostsCard) => void;
}

export default function SharedPanelsCardEditionSidebarPaginationSort({
  card,
  setCard,
}: SharedPanelsCardEditionSidebarPaginationSortProps) {
  const locale = useCurrentUserLocale();
  const cardSort = getPostSort(card);
  return (
    <Dropdown
      label="Sort"
      onChange={({ value }) =>
        setCard(editSortOnPostCard(card, value as Sort["on"]))
      }
      value={{
        value: cardSort,
        label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::SORT_BY_" + cardSort),
      }}
      options={map(["date", Metric.Engagement, Metric.Reach], (unit) => ({
        value: unit,
        label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::SORT_BY_" + unit),
      }))}
    />
  );
}
